// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentWithSignatureUpload {
    static getAttributeTypeMap() {
        return EnrollmentWithSignatureUpload.attributeTypeMap;
    }
}
EnrollmentWithSignatureUpload.discriminator = undefined;
EnrollmentWithSignatureUpload.additionalProperties = false;
EnrollmentWithSignatureUpload.attributeTypeMap = [
    {
        "name": "enrollmentRequest",
        "baseName": "enrollmentRequest",
        "type": "EnrollPatientRequestModel"
    },
    {
        "name": "signatureDocumentUpload",
        "baseName": "signatureDocumentUpload",
        "type": "SignatureDocumentUpload"
    },
];
//# sourceMappingURL=enrollmentWithSignatureUpload.js.map